import React, { useState, useEffect } from 'react';
import { useFormContext } from '../../../../../../providers';
import axios from 'axios';
import BASE_URL from '../../../../../auth/Baseurl';
import Select from 'react-select';

const CancellationPolicies = ({ field }) => {
    const [policies, setPolicies] = useState([]);
    const { errors, watch, setValue } = useFormContext();

    // Fetch the data from the API on component mount
    useEffect(() => {
        const fetchPolicies = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/cancellation-policy`, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                });
                setPolicies(response.data?.data || []);
            } catch (error) {
                console.error('Error fetching cancellation policies:', error);
            }
        };

        fetchPolicies();
    }, []);

    const selectedPolicy = watch(field);

    // Convert policies to react-select format
    const getOptions = () => {
        const policyType = field === 'cancellation_policy_short' ? 'short' : 'long';
        return policies
            .filter((policy) => policy.type === policyType)
            .map((policy) => ({
                value: policy.id,
                label: `${policy.group_name}: ${policy.before_check_in}`,
            }));
    };

    const handleChange = (selectedOption) => {
        setValue(field, selectedOption ? selectedOption.value : null);
    };

    // Find the currently selected option
    const selectedOption = getOptions().find(option => option.value === selectedPolicy);

    return (
        <div className="mt-2 text-left md:col-span-12" style={{ maxWidth: '780px' }}>
            <Select
                placeholder="Choose a cancellation policy"
                options={getOptions()}
                value={selectedOption}
                className='!m-0'
                onChange={handleChange}
                isClearable
                styles={{
                    input: (base) => ({
                        ...base,
                        margin: 0,

                    }),
                    control: (base) => ({
                        ...base,
                        minHeight: '48px',
                        borderRadius: '6px',
                        borderColor: errors?.[field] ? '#dc3545' : '#ced4da',
                        margin: 0,
                    }),
                    option: (base) => ({
                        ...base,
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                        padding: '8px 12px',
                    }),
                    menu: (base) => ({
                        ...base,
                        width: '540px',
                        maxWidth: '100%',
                    }),
                    singleValue: (base) => ({
                        ...base,
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                    }),
                }}
                theme={(theme) => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary: '#4f46e5', // indigo-600
                        primary25: '#e0e7ff', // indigo-100
                    },
                })}
            />

            {errors?.[field] && (
                <p className="mt-1 text-sm text-red-600">
                    {errors[field].message}
                </p>
            )}
        </div>
    );
};

export default CancellationPolicies;